import { REACT_APP_LIFERAY_HOST, REACT_APP_OAUTH_CLIENT_ID, REACT_APP_OAUTH_CLIENT_SECRET } from "./utils";

class CategorieService {
  constructor() {
    this.liferayConfig = {
      baseUrl: window?.Liferay
        ? window.Liferay.ThemeDisplay.getPortalURL()
        : REACT_APP_LIFERAY_HOST,
    };
    this._accessToken = null;
  }

  async getAccessToken() {
    if (this._accessToken) return this._accessToken;

    const res = await fetch(this.liferayConfig.baseUrl + '/o/oauth2/token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        grant_type:    'client_credentials',
        client_id:     REACT_APP_OAUTH_CLIENT_ID,
        client_secret: REACT_APP_OAUTH_CLIENT_SECRET,
      }).toString(),
    });

    if (!res.ok) throw new Error(`OAuth error: HTTP ${res.status}`);
    const data = await res.json();
    if (!data.access_token) throw new Error('OAuth: access_token absent');

    this._accessToken = data.access_token;
    return this._accessToken;
  }

  async allCategorie() {
    try {
      const accessToken = await this.getAccessToken();

      // ✅ Une seule requête avec pageSize=100 — évite la pagination bloquée par le WAF
      const url = `${this.liferayConfig.baseUrl}/o/c/cmapsitebicicis?pageSize=200`;

      const res = await fetch(url, {
        headers: {
          'Accept':        'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!res.ok) throw new Error(`API error: HTTP ${res.status}`);

      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.warn('[CategorieService] JSON invalide, tentative de correction...', e.message);
        try {
          const cleaned = text
            .replace(/:\s*\*+[\w.]*/g, ': null')
            .replace(/:\s*-\s*([,\}\]\n])/g, ': null$1')
            .replace(/:\s*-\s*$/gm, ': null');
          data = JSON.parse(cleaned);
          console.warn('[CategorieService] JSON corrigé — corrigez les données dans Liferay !');
        } catch (e2) {
          console.error('[CategorieService] JSON impossible à corriger :', e2.message);
          return [];
        }
      }

      const items = data?.items || [];
      console.log(`[CategorieService] Total agences chargées : ${items.length}`);
      return items;

    } catch (error) {
      console.error('[CategorieService]', error);
      return [];
    }
  }
}

export default CategorieService;